import Decimal from 'decimal.js';

export default function productUnitPriceDisplay(product, customSeparator = null) {
  const startFrom = product.maxPrice === product.minPrice ? '' : 'A partir de ';
  const unit = product.isKilogram ? ' Kg' : '';
  const display = `${startFrom}R$ ${Decimal(product.minPrice).toFixed(2)}${unit}`;
  return customSeparator ? display.replace('.', customSeparator) : display;
}
